import { Component } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 'acc-new-contact-success',
  standalone: true,
  imports: [MatDialogModule, MatButton],
  templateUrl: './new-contact-success.component.html',
  styleUrl: './new-contact-success.component.scss',
})
export class AccountNewContactSuccessComponent {}
